<template>
    <div class="panel panel-info">
        <div class="panel-heading">
            <i class="fa fa-user-secret" aria-hidden="true"></i> {{title}}
        </div>
        <div class="panel-body" >

            <div class="form-group">
                <div class="col-lg-10">

                    <div class="checkbox">
                        <label>
                            <input :disabled="disabled" v-model="permissoes.financeiro" type="checkbox"> MÓDULO FINANCEIRO
                        </label>
                    </div>

                    <div class="checkbox">
                        <label>
                            <input :disabled="disabled" v-model="permissoes.ordem_servico" type="checkbox"> MÓDULO DE ORDEM DE SERVIÇO
                        </label>
                    </div>

                    <div class="checkbox">
                        <label>
                            <input :disabled="disabled" v-model="permissoes.comandos" type="checkbox"> MÓDULO DE COMANDOS
                        </label>
                    </div>

                </div>
            </div>

        </div>
    </div>
</template>
<script>
import { Permissoes } from "../../class/permissoes";
export default {
    props: {
        permissoes: {
            type: Object,
            default: () => Permissoes.create()
        },
        disabled: {
            default: false
        },
        title: {
            default: "PERMISSÕES"
        }
    }
};
</script>
